/**
 * SessionExpiredRedirect — renvoie vers `/login` quand la session expire en
 * cours d'usage (SAAS-1266).
 *
 * @remarks
 * Quand le refresh du jeton échoue, le store se vide mais rien ne naviguait :
 * l'utilisateur restait sur l'écran et chaque action suivante échouait en toast
 * générique. Monté dans la zone authentifiée seulement — une page publique
 * reste lisible sans session.
 *
 * `/login` reçoit la page quittée (`?redirect=…`) pour y revenir après
 * connexion, et `state.sessionExpired` pour expliquer pourquoi on y est.
 */

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/app/stores/use-auth-store';
import { loginPath } from '@/lib/auth/redirect';

export function SessionExpiredRedirect() {
  const sessionExpired = useAuthStore((s) => s.sessionExpired);
  const acknowledge = useAuthStore((s) => s.acknowledgeSessionExpired);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!sessionExpired) return;
    acknowledge();
    void navigate(loginPath(`${pathname}${search}`), {
      replace: true,
      state: { sessionExpired: true },
    });
  }, [sessionExpired, acknowledge, navigate, pathname, search]);

  return null;
}
